/* vd-pdp.js — Verdia island plumbing: countdown, header drawer, gallery, tiers, gifts, ATC, sticky bar, popup.
   Vanilla, namespaced window.vd*. Prices come from data-price/data-compare (Liquid cents) + window.vdMoney. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = window.vdMoney || '${{amount}}';
    var n = Number(cents) / 100;
    var out;
    if (/amount_no_decimals/.test(fmt)) out = Math.round(n).toLocaleString('en-US');
    else if (/amount_with_comma_separator/.test(fmt)) out = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    else out = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, out);
  }
  function moneyNoZeros(cents) {
    var s = money(cents);
    return s.replace(/[.,]00(?=\D*$)/, '');
  }
  window.vdMoneyFmt = money;

  /* ---------- countdown (resets at local midnight) ---------- */
  function countdown() {
    var els = $$('[data-vd-countdown]');
    if (!els.length) return;
    function tick() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
      var d = Math.max(0, end - now) / 1000;
      var h = Math.floor(d / 3600), m = Math.floor((d % 3600) / 60), s = Math.floor(d % 60);
      var t = [h, m, s].map(function (x) { return (x < 10 ? '0' : '') + x; }).join(':');
      els.forEach(function (e) { e.textContent = t; });
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- header drawer ---------- */
  function drawer() {
    var d = $('[data-vd-drawer]'); if (!d) return;
    var open = function () { d.hidden = false; document.body.classList.add('vd-drawer-open'); $$('[data-vd-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); }); };
    var close = function () { d.hidden = true; document.body.classList.remove('vd-drawer-open'); $$('[data-vd-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); };
    $$('[data-vd-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-vd-drawer-close], [data-vd-drawer-link]', d).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- gallery ---------- */
  function gallery(root) {
    var track = $('[data-vd-gallery-track]', root); if (!track) return;
    var slides = $$('[data-vd-slide]', track), thumbs = $$('[data-vd-thumb]', root);
    var i = 0;
    function go(n, smooth) {
      i = (n + slides.length) % slides.length;
      var s = slides[i];
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      var at = thumbs[i]; if (at && at.scrollIntoView) at.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
    var prev = $('[data-vd-gallery-prev]', root), next = $('[data-vd-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.dataset.index)); }); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var w = track.clientWidth || 1; var n = Math.round(track.scrollLeft / w);
        if (n !== i && n >= 0 && n < slides.length) { i = n; thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); }); }
      });
    }, { passive: true });
  }

  /* ---------- buy box: tiers, gifts, prices, ATC ---------- */
  function buybox(root) {
    var tiers = $$('[data-vd-tier]', root); if (!tiers.length) return;
    var atc = $('[data-vd-atc]', root);
    var gifts = $$('[data-vd-gift]', root);
    var set = function (t) {
      tiers.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      var price = Number(t.dataset.price), cmp = Number(t.dataset.compare) || price, save = Math.max(0, cmp - price);
      var idx = Number(t.dataset.tierIndex) || 1;
      $$('[data-vd-price]', root).forEach(function (e) { e.textContent = money(price); });
      $$('[data-vd-compare]', root).forEach(function (e) { e.textContent = cmp > price ? money(cmp) : ''; });
      $$('[data-vd-save]', root).forEach(function (e) { e.textContent = moneyNoZeros(Math.round(save / 100) * 100); });
      $$('[data-vd-atc-price]', root).forEach(function (e) { e.textContent = money(price); });
      $$('[data-vd-atc-compare]', root).forEach(function (e) { e.textContent = cmp > price ? money(cmp) : ''; });
      if (atc) atc.dataset.variantId = t.dataset.variantId;
      gifts.forEach(function (g) { g.classList.toggle('is-locked', idx < Number(g.dataset.unlockTier || 1)); });
      /* sticky bar mirrors the last selection */
      var sp = $('[data-vd-sticky-price]'), sc = $('[data-vd-sticky-compare]');
      if (sp) sp.textContent = money(price);
      if (sc) sc.textContent = cmp > price ? money(cmp) : '';
      window.vdSelectedVariant = t.dataset.variantId;
    };
    tiers.forEach(function (t) { t.addEventListener('click', function () { set(t); }); });
    var active = tiers.filter(function (t) { return t.classList.contains('is-active'); })[0] || tiers[0];
    set(active);

    if (atc) atc.addEventListener('click', function () {
      var id = atc.dataset.variantId; if (!id) return;
      var msg = $('[data-vd-atc-msg]', root);
      atc.classList.add('is-busy'); atc.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
        .then(function (r) {
          var ct = r.headers.get('content-type') || '';
          if (!r.ok || ct.indexOf('text/html') >= 0) throw new Error('cart ' + r.status);
          return r.json();
        })
        .then(function () {
          // AddToCart is tracked by the Customer Events pixel (richer payload + eventID for CAPI dedup).
          window.location.href = '/cart';
        })
        .catch(function () {
          atc.classList.remove('is-busy'); atc.disabled = false;
          if (msg) { msg.hidden = false; msg.textContent = 'The cart is busy for a moment. Please tap Add To Cart again.'; }
        });
    });
  }

  /* ---------- sticky bar ---------- */
  function sticky() {
    var bar = $('[data-vd-sticky]'); var atc = $('#vd-buy [data-vd-atc]'); if (!bar || !atc) return;
    var go = $('[data-vd-sticky-go]', bar);
    if (go) go.addEventListener('click', function (e) { e.preventDefault(); atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    if (!('IntersectionObserver' in window)) return;
    var passed = false;
    new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (x.isIntersecting) { passed = false; bar.hidden = true; }
        else if (x.boundingClientRect.top < 0) { passed = true; bar.hidden = false; }
        else { bar.hidden = true; }
      });
    }, { threshold: 0 }).observe(atc);
  }

  /* ---------- popup ---------- */
  function popup() {
    var p = $('[data-vd-popup]'); if (!p) return;
    var KEY = 'vdPopupSeen';
    var seen = false; try { seen = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    if (seen || (window.Shopify && Shopify.designMode)) return;
    var close = function () { p.hidden = true; document.body.classList.remove('vd-popup-open'); try { sessionStorage.setItem(KEY, '1'); } catch (e) {} };
    $$('[data-vd-popup-close]', p).forEach(function (b) { b.addEventListener('click', close); });
    var form = $('[data-vd-popup-form]', p);
    var show = function (n) { $$('[data-vd-popup-step]', p).forEach(function (s) { s.hidden = s.dataset.vdPopupStep !== String(n); }); };
    var nx = $('[data-vd-popup-next]', p); if (nx) nx.addEventListener('click', function () { show(2); var i = $('input', form); if (i) i.focus(); });
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = ($('input', form) || {}).value || '';
      var fd = new FormData(); fd.append('form_type', 'customer'); fd.append('utf8', '✓'); fd.append('contact[email]', email); fd.append('contact[tags]', 'newsletter,verdia,popup');
      fetch('/contact#contact_form', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
      show(3);
    });
    setTimeout(function () { p.hidden = false; document.body.classList.add('vd-popup-open'); }, (Number(p.dataset.delay) || 8) * 1000);
  }

  function init() {
    countdown(); drawer();
    $$('[data-vd-buybox]').forEach(function (b) { gallery(b); buybox(b); });
    sticky(); popup();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
